// Chapters Within — Your Story :: i18n bundle (10 languages)
// Self-contained translations used only by ChaptersWithinSection.jsx

const chaptersWithinTranslations = {
  en: {
    sectionTitle: "Chapters Within",
    sectionSubtitle: "Your Story.",
    sectionTagline: "Every book you read becomes a chapter in the story of who you are becoming.",
    sanctuaryLabel: "A Private Reading Sanctuary — Coming Soon",
    sanctuaryNote: "Share your reflection today. Your personal sanctuary is being built. We will bring it to you soon.",
    cta: "Capture a Chapter",
    modal: {
      heading: "Your Chapter",
      subheading: "Capture what this book gave you.",
      step1: {
        roman: "I",
        heading: "Which book are you reflecting on?",
        placeholder: "Title or author…",
        hint: "Search our library or enter any book you have read.",
        authorPlaceholder: "Author (optional)…",
      },
      step2: {
        roman: "II",
        heading: "What did this book give you?",
        optional: "Optional",
        cards: {
          reflection: {
            label: "My Reflection",
            subtitle: "What stayed with you?",
            micLabel: "Speak Your Reflection",
            micHint: "Tap to record. We'll write it for you.",
            micListening: "Listening…",
            micUnsupported: "Voice input isn't supported in this browser. Please type your reflection.",
            placeholder: "Or write your reflection here…",
          },
          practice: {
            label: "Ideas to Practice",
            subtitle: "What will you actually do differently?",
            placeholder: "Write one or two things you want to try…",
          },
          passage: {
            label: "A Passage to Remember",
            subtitle: "A line or idea from the book worth keeping",
            placeholder: "Write a passage that moved you…",
          },
          revisit: {
            label: "Revisit Later",
            subtitle: "Something worth returning to",
            placeholder: "A chapter, an idea, a question to sit with…",
          },
        },
      },
      step3: {
        roman: "III",
        heading: "About you",
        subheading: "So we know whose story this belongs to.",
        namePlaceholder: "Your name…",
        emailPlaceholder: "Your email (so we can reach you when your sanctuary is ready)…",
        emailNote: "We will never share your email. We will only write to you when Chapters Within is ready for you.",
      },
      submit: "Seal My Chapter",
      submitting: "Sealing…",
      bottomTagline: "This remembers who you are becoming.",
      validationGeneric: "This chapter needs a little more before it can be sealed.",
      validationEmail: "Please share a valid email so we can reach you.",
      submitErrorGeneric: "Something went wrong. Please try again.",
      close: "Close",
    },
    confirmation: {
      heading: "Your Chapter has been sealed.",
      subtitle: "We have received your reflection with care. When your personal sanctuary is ready, you will be the first to know.",
      signoff: "— The iCraftz Library",
    },
  },

  hi: {
    sectionTitle: "भीतरी अध्याय",
    sectionSubtitle: "आपकी कहानी।",
    sectionTagline: "आपके पढ़ी हर किताब, उस कहानी का एक अध्याय बन जाती है जो आप बन रहे हैं।",
    sanctuaryLabel: "एक निजी पठन आश्रय — जल्द आ रहा है",
    sanctuaryNote: "आज ही अपने विचार साझा करें। आपका निजी आश्रय बनाया जा रहा है। हम जल्द ही इसे आपके पास लाएंगे।",
    cta: "एक अध्याय कैद करें",
    modal: {
      heading: "आपका अध्याय",
      subheading: "इस किताब ने आपको जो दिया, उसे कैद कीजिए।",
      step1: {
        roman: "I",
        heading: "किस किताब पर विचार कर रहे हैं?",
        placeholder: "शीर्षक या लेखक…",
        hint: "हमारी लाइब्रेरी में खोजें या जो किताब पढ़ी है, वह दर्ज करें।",
        authorPlaceholder: "लेखक (वैकल्पिक)…",
      },
      step2: {
        roman: "II",
        heading: "इस किताब ने आपको क्या दिया?",
        optional: "वैकल्पिक",
        cards: {
          reflection: {
            label: "मेरा विचार",
            subtitle: "क्या आपके साथ रह गया?",
            micLabel: "अपना विचार बोलें",
            micHint: "रिकॉर्ड करने के लिए टैप करें। हम लिख लेंगे।",
            micListening: "सुन रहे हैं…",
            micUnsupported: "इस ब्राउज़र में आवाज़ इनपुट उपलब्ध नहीं है। कृपया लिखकर साझा करें।",
            placeholder: "या यहाँ अपना विचार लिखें…",
          },
          practice: {
            label: "अमल में लाने योग्य विचार",
            subtitle: "आप वास्तव में क्या अलग करेंगे?",
            placeholder: "एक या दो बातें लिखें जो आप आजमाना चाहते हैं…",
          },
          passage: {
            label: "याद रखने योग्य अंश",
            subtitle: "किताब की एक पंक्ति या विचार जो रखने योग्य है",
            placeholder: "एक अंश लिखें जिसने आपको प्रभावित किया…",
          },
          revisit: {
            label: "बाद में लौटें",
            subtitle: "कुछ ऐसा जिस पर लौटना सार्थक है",
            placeholder: "एक अध्याय, विचार, या साथ बैठने योग्य प्रश्न…",
          },
        },
      },
      step3: {
        roman: "III",
        heading: "आपके बारे में",
        subheading: "ताकि हम जानें कि यह कहानी किसकी है।",
        namePlaceholder: "आपका नाम…",
        emailPlaceholder: "आपका ईमेल (ताकि आपका आश्रय तैयार होने पर हम आपसे जुड़ सकें)…",
        emailNote: "हम आपका ईमेल कभी साझा नहीं करेंगे। केवल जब Chapters Within आपके लिए तैयार होगा, तभी लिखेंगे।",
      },
      submit: "मुहर लगाकर सहेजें",
      submitting: "सहेजा जा रहा है…",
      bottomTagline: "यह याद रखता है कि आप क्या बन रहे हैं।",
      validationGeneric: "इस अध्याय को मुहरबंद करने के लिए थोड़ा और चाहिए।",
      validationEmail: "कृपया एक सही ईमेल दर्ज करें।",
      submitErrorGeneric: "कुछ गलत हुआ। कृपया फिर कोशिश करें।",
      close: "बंद करें",
    },
    confirmation: {
      heading: "आपका अध्याय मुहरबंद हो गया है।",
      subtitle: "हमने आपके विचार ध्यान से प्राप्त किए हैं। जब आपका निजी आश्रय तैयार होगा, सबसे पहले आप जानेंगे।",
      signoff: "— iCraftz पुस्तकालय",
    },
  },

  te: {
    sectionTitle: "లోపలి అధ్యాయాలు",
    sectionSubtitle: "మీ కథ.",
    sectionTagline: "మీరు చదివే ప్రతి పుస్తకం మీరవుతున్న మనిషి కథలో ఒక అధ్యాయం అవుతుంది.",
    sanctuaryLabel: "ఒక వ్యక్తిగత పఠన ఆశ్రయం — త్వరలో",
    sanctuaryNote: "ఈరోజు మీ ప్రతిబింబాన్ని పంచుకోండి. మీ వ్యక్తిగత ఆశ్రయం నిర్మాణంలో ఉంది. త్వరలోనే మీకు తీసుకువస్తాము.",
    cta: "ఒక అధ్యాయాన్ని బంధించండి",
    modal: {
      heading: "మీ అధ్యాయం",
      subheading: "ఈ పుస్తకం మీకు ఇచ్చిన దాన్ని బంధించండి.",
      step1: { roman: "I", heading: "ఏ పుస్తకం గురించి ప్రతిబింబిస్తున్నారు?", placeholder: "శీర్షిక లేదా రచయిత…", hint: "మా గ్రంథాలయంలో శోధించండి లేదా మీరు చదివిన పుస్తకాన్ని నమోదు చేయండి.", authorPlaceholder: "రచయిత (ఐచ్ఛికం)…" },
      step2: {
        roman: "II", heading: "ఈ పుస్తకం మీకు ఏమి ఇచ్చింది?", optional: "ఐచ్ఛికం",
        cards: {
          reflection: { label: "నా ప్రతిబింబం", subtitle: "ఏది మీతో మిగిలిపోయింది?", micLabel: "మీ ప్రతిబింబాన్ని మాట్లాడండి", micHint: "రికార్డ్ చేయడానికి నొక్కండి.", micListening: "వింటున్నాము…", micUnsupported: "ఈ బ్రౌజర్‌లో వాయిస్ ఇన్‌పుట్ లేదు. దయచేసి టైప్ చేయండి.", placeholder: "లేదా ఇక్కడ రాయండి…" },
          practice: { label: "ఆచరించాల్సిన ఆలోచనలు", subtitle: "మీరు నిజంగా ఏమి భిన్నంగా చేస్తారు?", placeholder: "ప్రయత్నించాలనుకునే ఒకటి లేదా రెండు విషయాలను రాయండి…" },
          passage: { label: "గుర్తుంచుకోదగిన భాగం", subtitle: "పుస్తకం నుండి విలువైన పంక్తి", placeholder: "మిమ్మల్ని కదిలించిన భాగం రాయండి…" },
          revisit: { label: "తరువాత తిరిగి చూడండి", subtitle: "తిరిగి రావడానికి విలువైనది", placeholder: "ఒక అధ్యాయం, ఆలోచన, లేదా కలిసి కూర్చోదగిన ప్రశ్న…" },
        },
      },
      step3: { roman: "III", heading: "మీ గురించి", subheading: "ఈ కథ ఎవరిదో మాకు తెలిసేలా.", namePlaceholder: "మీ పేరు…", emailPlaceholder: "మీ ఇమెయిల్ (మీ ఆశ్రయం సిద్ధమైనప్పుడు చేరుకోవడానికి)…", emailNote: "మేము మీ ఇమెయిల్‌ను ఎన్నడూ పంచుకోము. Chapters Within మీకు సిద్ధమైనప్పుడే రాస్తాము." },
      submit: "నా అధ్యాయాన్ని ముద్రవేయి", submitting: "ముద్ర వేస్తున్నాము…", bottomTagline: "ఇది మీరు అవుతున్నది గుర్తుంచుకుంటుంది.",
      validationGeneric: "ఈ అధ్యాయాన్ని ముద్రించడానికి కొంచెం ఎక్కువ అవసరం.", validationEmail: "దయచేసి సరైన ఇమెయిల్‌ను ఇవ్వండి.", submitErrorGeneric: "ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.", close: "మూసివేయి",
    },
    confirmation: { heading: "మీ అధ్యాయం ముద్రవేయబడింది.", subtitle: "మేము మీ ప్రతిబింబాన్ని జాగ్రత్తగా అందుకున్నాము. మీ ఆశ్రయం సిద్ధమైనప్పుడు మీరు మొదటివారు తెలుసుకుంటారు.", signoff: "— iCraftz గ్రంథాలయం" },
  },

  ta: {
    sectionTitle: "உள் அத்தியாயங்கள்", sectionSubtitle: "உங்கள் கதை.",
    sectionTagline: "நீங்கள் படிக்கும் ஒவ்வொரு புத்தகமும் நீங்கள் ஆகிக்கொண்டிருக்கும் கதையில் ஒரு அத்தியாயம் ஆகிறது.",
    sanctuaryLabel: "ஒரு தனிப்பட்ட வாசிப்பு புகலிடம் — விரைவில்",
    sanctuaryNote: "இன்றே உங்கள் பிரதிபலிப்பைப் பகிருங்கள். உங்கள் தனிப்பட்ட புகலிடம் கட்டப்படுகிறது. விரைவில் உங்களுக்குக் கொண்டுவருவோம்.",
    cta: "ஒரு அத்தியாயத்தை பதிவுசெய்க",
    modal: {
      heading: "உங்கள் அத்தியாயம்", subheading: "இந்த புத்தகம் உங்களுக்கு கொடுத்ததை பதிவுசெய்க.",
      step1: { roman: "I", heading: "எந்த புத்தகத்தை பற்றி பிரதிபலிக்கிறீர்கள்?", placeholder: "தலைப்பு அல்லது எழுத்தாளர்…", hint: "எங்கள் நூலகத்தில் தேடுங்கள் அல்லது நீங்கள் படித்த புத்தகத்தை உள்ளிடுங்கள்.", authorPlaceholder: "எழுத்தாளர் (விருப்பம்)…" },
      step2: { roman: "II", heading: "இந்த புத்தகம் உங்களுக்கு என்ன கொடுத்தது?", optional: "விருப்பம்",
        cards: {
          reflection: { label: "என் பிரதிபலிப்பு", subtitle: "என்ன உங்களுடன் தங்கியது?", micLabel: "உங்கள் பிரதிபலிப்பை பேசுங்கள்", micHint: "பதிவுசெய்ய தட்டுங்கள்.", micListening: "கேட்கிறோம்…", micUnsupported: "இந்த உலாவியில் குரல் உள்ளீடு இல்லை. தட்டச்சு செய்க.", placeholder: "அல்லது இங்கே எழுதுங்கள்…" },
          practice: { label: "செயல்படுத்த வேண்டிய எண்ணங்கள்", subtitle: "எதை உண்மையில் வேறுபட்டு செய்வீர்கள்?", placeholder: "முயற்சிக்க விரும்பும் ஒன்று இரண்டை எழுதுங்கள்…" },
          passage: { label: "நினைவு கூர வேண்டிய பகுதி", subtitle: "வைத்திருக்க தகுதியான வரி", placeholder: "உங்களை அசைத்த பகுதியை எழுதுங்கள்…" },
          revisit: { label: "பிறகு திரும்பவும்", subtitle: "திரும்ப மதிப்பானது", placeholder: "ஒரு அத்தியாயம், ஒரு எண்ணம், ஒரு கேள்வி…" },
        },
      },
      step3: { roman: "III", heading: "உங்களைப் பற்றி", subheading: "இந்த கதை யாருக்கானது என்று தெரிய.", namePlaceholder: "உங்கள் பெயர்…", emailPlaceholder: "உங்கள் மின்னஞ்சல்…", emailNote: "உங்கள் மின்னஞ்சலை யாருடனும் பகிர மாட்டோம். Chapters Within தயாராகும்போது மட்டுமே எழுதுவோம்." },
      submit: "என் அத்தியாயத்தை முத்திரையிடு", submitting: "முத்திரையிடுகிறோம்…", bottomTagline: "இது நீங்கள் ஆகிக்கொண்டிருப்பதை நினைவில் கொள்கிறது.",
      validationGeneric: "இந்த அத்தியாயத்தை முத்திரையிட இன்னும் கொஞ்சம் தேவை.", validationEmail: "சரியான மின்னஞ்சலை வழங்கவும்.", submitErrorGeneric: "ஏதோ தவறு. மீண்டும் முயற்சிக்கவும்.", close: "மூடு",
    },
    confirmation: { heading: "உங்கள் அத்தியாயம் முத்திரையிடப்பட்டது.", subtitle: "உங்கள் பிரதிபலிப்பை கவனமாக பெற்றோம். உங்கள் புகலிடம் தயாரானதும் முதலில் நீங்களே அறிவீர்கள்.", signoff: "— iCraftz நூலகம்" },
  },

  kn: {
    sectionTitle: "ಒಳಗಿನ ಅಧ್ಯಾಯಗಳು", sectionSubtitle: "ನಿಮ್ಮ ಕಥೆ.",
    sectionTagline: "ನೀವು ಓದುವ ಪ್ರತಿಯೊಂದು ಪುಸ್ತಕವೂ ನೀವಾಗುತ್ತಿರುವವರ ಕಥೆಯಲ್ಲಿ ಒಂದು ಅಧ್ಯಾಯವಾಗುತ್ತದೆ.",
    sanctuaryLabel: "ಒಂದು ಖಾಸಗಿ ಓದುವ ಆಶ್ರಯ — ಶೀಘ್ರದಲ್ಲೇ",
    sanctuaryNote: "ಇಂದು ನಿಮ್ಮ ಪ್ರತಿಬಿಂಬವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ. ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಆಶ್ರಯವನ್ನು ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ. ಶೀಘ್ರವೇ ತರುತ್ತೇವೆ.",
    cta: "ಒಂದು ಅಧ್ಯಾಯವನ್ನು ಸೆರೆಹಿಡಿಯಿರಿ",
    modal: {
      heading: "ನಿಮ್ಮ ಅಧ್ಯಾಯ", subheading: "ಈ ಪುಸ್ತಕ ನಿಮಗೆ ನೀಡಿದ್ದನ್ನು ಸೆರೆಹಿಡಿಯಿರಿ.",
      step1: { roman: "I", heading: "ಯಾವ ಪುಸ್ತಕದ ಬಗ್ಗೆ ಪ್ರತಿಬಿಂಬಿಸುತ್ತಿದ್ದೀರಿ?", placeholder: "ಶೀರ್ಷಿಕೆ ಅಥವಾ ಲೇಖಕ…", hint: "ಗ್ರಂಥಾಲಯದಲ್ಲಿ ಹುಡುಕಿ ಅಥವಾ ಓದಿದ ಪುಸ್ತಕವನ್ನು ನಮೂದಿಸಿ.", authorPlaceholder: "ಲೇಖಕ (ಐಚ್ಛಿಕ)…" },
      step2: { roman: "II", heading: "ಈ ಪುಸ್ತಕ ನಿಮಗೇನು ಕೊಟ್ಟಿತು?", optional: "ಐಚ್ಛಿಕ",
        cards: {
          reflection: { label: "ನನ್ನ ಪ್ರತಿಬಿಂಬ", subtitle: "ಏನು ನಿಮ್ಮೊಂದಿಗೆ ಉಳಿಯಿತು?", micLabel: "ನಿಮ್ಮ ಪ್ರತಿಬಿಂಬವನ್ನು ಮಾತನಾಡಿ", micHint: "ರೆಕಾರ್ಡ್ ಮಾಡಲು ಒತ್ತಿ.", micListening: "ಕೇಳುತ್ತಿದ್ದೇವೆ…", micUnsupported: "ಧ್ವನಿ ಇನ್‌ಪುಟ್ ಬೆಂಬಲಿತವಲ್ಲ. ಟೈಪ್ ಮಾಡಿ.", placeholder: "ಅಥವಾ ಇಲ್ಲಿ ಬರೆಯಿರಿ…" },
          practice: { label: "ಆಚರಣೆಗೆ ಆಲೋಚನೆಗಳು", subtitle: "ನೀವು ನಿಜವಾಗಿ ಏನು ಬೇರೆಯಾಗಿ ಮಾಡುತ್ತೀರಿ?", placeholder: "ಪ್ರಯತ್ನಿಸಲು ಬಯಸುವ ಒಂದು ಅಥವಾ ಎರಡು ವಿಷಯಗಳನ್ನು ಬರೆಯಿರಿ…" },
          passage: { label: "ನೆನಪಿಡಲು ಯೋಗ್ಯ ಭಾಗ", subtitle: "ಪುಸ್ತಕದಿಂದ ಇಡಲು ಯೋಗ್ಯ ಸಾಲು", placeholder: "ನಿಮ್ಮನ್ನು ಚಲಿಸಿದ ಭಾಗವನ್ನು ಬರೆಯಿರಿ…" },
          revisit: { label: "ನಂತರ ಮರಳಿ", subtitle: "ಮರಳಲು ಯೋಗ್ಯವಾದದ್ದು", placeholder: "ಒಂದು ಅಧ್ಯಾಯ, ಒಂದು ಆಲೋಚನೆ…" },
        },
      },
      step3: { roman: "III", heading: "ನಿಮ್ಮ ಬಗ್ಗೆ", subheading: "ಈ ಕಥೆ ಯಾರದ್ದು ಎಂದು ತಿಳಿಯಲು.", namePlaceholder: "ನಿಮ್ಮ ಹೆಸರು…", emailPlaceholder: "ನಿಮ್ಮ ಇಮೇಲ್…", emailNote: "ನಾವು ನಿಮ್ಮ ಇಮೇಲ್ ಅನ್ನು ಎಂದಿಗೂ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ. Chapters Within ಸಿದ್ಧವಾದಾಗ ಮಾತ್ರ ಬರೆಯುತ್ತೇವೆ." },
      submit: "ನನ್ನ ಅಧ್ಯಾಯವನ್ನು ಮುದ್ರೆ ಮಾಡಿ", submitting: "ಮುದ್ರೆ ಮಾಡುತ್ತಿದ್ದೇವೆ…", bottomTagline: "ಇದು ನೀವಾಗುತ್ತಿರುವದನ್ನು ನೆನಪಿಡುತ್ತದೆ.",
      validationGeneric: "ಈ ಅಧ್ಯಾಯವನ್ನು ಮುದ್ರಿಸಲು ಸ್ವಲ್ಪ ಹೆಚ್ಚು ಬೇಕಾಗಿದೆ.", validationEmail: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಇಮೇಲ್ ನೀಡಿ.", submitErrorGeneric: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.", close: "ಮುಚ್ಚು",
    },
    confirmation: { heading: "ನಿಮ್ಮ ಅಧ್ಯಾಯ ಮುದ್ರೆಯಾಗಿದೆ.", subtitle: "ನಾವು ಜಾಗ್ರತೆಯಿಂದ ಸ್ವೀಕರಿಸಿದ್ದೇವೆ. ಆಶ್ರಯ ಸಿದ್ಧವಾದಾಗ ನೀವೇ ಮೊದಲು ತಿಳಿಯುವಿರಿ.", signoff: "— iCraftz ಗ್ರಂಥಾಲಯ" },
  },

  mr: {
    sectionTitle: "अंतर्गत अध्याय", sectionSubtitle: "तुमची कथा.",
    sectionTagline: "तुम्ही वाचलेले प्रत्येक पुस्तक तुम्ही जे बनत आहात त्या कथेचा एक अध्याय बनते.",
    sanctuaryLabel: "एक खाजगी वाचन आश्रय — लवकरच",
    sanctuaryNote: "आज तुमचे विचार सामायिक करा. तुमचा वैयक्तिक आश्रय बांधला जात आहे. लवकरच तुमच्यापर्यंत आणू.",
    cta: "एक अध्याय टिपा",
    modal: {
      heading: "तुमचा अध्याय", subheading: "हे पुस्तक तुम्हाला काय दिले ते टिपा.",
      step1: { roman: "I", heading: "कोणत्या पुस्तकावर विचार करत आहात?", placeholder: "शीर्षक किंवा लेखक…", hint: "आमची ग्रंथालय शोधा किंवा वाचलेले पुस्तक प्रविष्ट करा.", authorPlaceholder: "लेखक (पर्यायी)…" },
      step2: { roman: "II", heading: "हे पुस्तक तुम्हाला काय दिले?", optional: "पर्यायी",
        cards: {
          reflection: { label: "माझे विचार", subtitle: "काय तुमच्यासोबत राहिले?", micLabel: "तुमचे विचार बोला", micHint: "रेकॉर्ड करण्यासाठी टॅप करा.", micListening: "ऐकत आहोत…", micUnsupported: "ब्राउझरमध्ये आवाज नाही. कृपया लिहा.", placeholder: "किंवा येथे लिहा…" },
          practice: { label: "अमलात आणण्यासाठी कल्पना", subtitle: "तुम्ही खरोखर काय वेगळे करणार?", placeholder: "तुम्ही प्रयत्न करू इच्छित असलेल्या एक दोन गोष्टी लिहा…" },
          passage: { label: "लक्षात ठेवण्यासारखा भाग", subtitle: "ठेवण्यासारखी ओळ", placeholder: "तुम्हाला हलवणारा भाग लिहा…" },
          revisit: { label: "पुन्हा भेटा", subtitle: "परत येण्यासारखे काही", placeholder: "एक अध्याय, एक कल्पना, एक प्रश्न…" },
        },
      },
      step3: { roman: "III", heading: "तुमच्याबद्दल", subheading: "ही कथा कोणाची आहे ते समजावे म्हणून.", namePlaceholder: "तुमचे नाव…", emailPlaceholder: "तुमचा ईमेल…", emailNote: "आम्ही तुमचा ईमेल कधीही सामायिक करणार नाही. Chapters Within तयार असेल तेव्हाच लिहू." },
      submit: "माझा अध्याय शिक्कामोर्तब करा", submitting: "शिक्का मारत आहोत…", bottomTagline: "हे लक्षात ठेवते तुम्ही काय बनत आहात.",
      validationGeneric: "हा अध्याय शिक्कामोर्तब करण्यासाठी थोडे अधिक हवे.", validationEmail: "कृपया वैध ईमेल द्या.", submitErrorGeneric: "काहीतरी चुकले. पुन्हा प्रयत्न करा.", close: "बंद करा",
    },
    confirmation: { heading: "तुमचा अध्याय शिक्कामोर्तब झाला.", subtitle: "आम्ही तुमचे विचार काळजीपूर्वक स्वीकारले. तुमचा आश्रय तयार होईल तेव्हा प्रथम तुम्हीच कळणार.", signoff: "— iCraftz ग्रंथालय" },
  },

  bn: {
    sectionTitle: "অভ্যন্তরীণ অধ্যায়", sectionSubtitle: "আপনার গল্প.",
    sectionTagline: "আপনি যে প্রতিটি বই পড়েন তা আপনি যা হয়ে উঠছেন সেই গল্পের একটি অধ্যায় হয়ে ওঠে.",
    sanctuaryLabel: "একটি ব্যক্তিগত পঠন আশ্রয় — শীঘ্রই আসছে",
    sanctuaryNote: "আজই আপনার ভাবনা ভাগ করুন। আপনার আশ্রয় তৈরি হচ্ছে। শীঘ্রই আনব।",
    cta: "একটি অধ্যায় ধরুন",
    modal: {
      heading: "আপনার অধ্যায়", subheading: "এই বই আপনাকে যা দিয়েছে তা ধরুন.",
      step1: { roman: "I", heading: "কোন বই নিয়ে ভাবছেন?", placeholder: "শিরোনাম বা লেখক…", hint: "আমাদের গ্রন্থাগারে অনুসন্ধান করুন বা যে বই পড়েছেন তা লিখুন.", authorPlaceholder: "লেখক (ঐচ্ছিক)…" },
      step2: { roman: "II", heading: "এই বই আপনাকে কী দিয়েছে?", optional: "ঐচ্ছিক",
        cards: {
          reflection: { label: "আমার ভাবনা", subtitle: "কী আপনার সাথে থেকেছে?", micLabel: "আপনার ভাবনা বলুন", micHint: "রেকর্ড করতে ট্যাপ করুন.", micListening: "শুনছি…", micUnsupported: "ব্রাউজারে কণ্ঠস্বর সমর্থিত নয়। টাইপ করুন.", placeholder: "অথবা এখানে লিখুন…" },
          practice: { label: "অনুশীলনের ধারণা", subtitle: "আপনি আসলে কী আলাদা করবেন?", placeholder: "চেষ্টা করতে চান এমন এক দুটি কথা লিখুন…" },
          passage: { label: "মনে রাখার মতো অংশ", subtitle: "রাখার মতো একটি লাইন", placeholder: "যা আপনাকে নাড়া দিয়েছে এমন অংশ লিখুন…" },
          revisit: { label: "পরে ফিরে আসুন", subtitle: "ফেরার মতো কিছু", placeholder: "একটি অধ্যায়, একটি ভাবনা, একটি প্রশ্ন…" },
        },
      },
      step3: { roman: "III", heading: "আপনার সম্পর্কে", subheading: "এই গল্প কার তা জানতে.", namePlaceholder: "আপনার নাম…", emailPlaceholder: "আপনার ইমেইল…", emailNote: "আমরা আপনার ইমেইল কখনও শেয়ার করব না. Chapters Within প্রস্তুত হলে শুধু লিখব." },
      submit: "আমার অধ্যায় সিল করুন", submitting: "সিল করছি…", bottomTagline: "এটি মনে রাখে আপনি কী হয়ে উঠছেন.",
      validationGeneric: "এই অধ্যায় সিল করতে আরও কিছু লাগবে.", validationEmail: "একটি বৈধ ইমেইল দিন.", submitErrorGeneric: "কিছু ভুল হয়েছে. আবার চেষ্টা করুন.", close: "বন্ধ করুন",
    },
    confirmation: { heading: "আপনার অধ্যায় সিল করা হয়েছে.", subtitle: "আমরা যত্ন করে গ্রহণ করেছি. আশ্রয় তৈরি হলে আপনিই প্রথম জানবেন.", signoff: "— iCraftz গ্রন্থাগার" },
  },

  gu: {
    sectionTitle: "આંતરિક અધ્યાય", sectionSubtitle: "તમારી વાર્તા.",
    sectionTagline: "તમે વાંચેલ દરેક પુસ્તક તમે જે બની રહ્યા છો તેની વાર્તાનો એક અધ્યાય બને છે.",
    sanctuaryLabel: "એક ખાનગી વાચન આશ્રય — ટૂંક સમયમાં",
    sanctuaryNote: "આજે તમારા વિચારો વહેંચો. તમારો આશ્રય બનાવાઈ રહ્યો છે. ટૂંક સમયમાં લાવીશું.",
    cta: "એક અધ્યાય સંગ્રહો",
    modal: {
      heading: "તમારો અધ્યાય", subheading: "આ પુસ્તકે તમને જે આપ્યું તે સંગ્રહો.",
      step1: { roman: "I", heading: "કયા પુસ્તક પર વિચાર કરો છો?", placeholder: "શીર્ષક અથવા લેખક…", hint: "અમારી ગ્રંથાલયમાં શોધો અથવા વાંચેલ પુસ્તક દાખલ કરો.", authorPlaceholder: "લેખક (વૈકલ્પિક)…" },
      step2: { roman: "II", heading: "આ પુસ્તકે તમને શું આપ્યું?", optional: "વૈકલ્પિક",
        cards: {
          reflection: { label: "મારા વિચાર", subtitle: "શું તમારી સાથે રહ્યું?", micLabel: "તમારા વિચાર બોલો", micHint: "રેકોર્ડ કરવા ટેપ કરો.", micListening: "સાંભળી રહ્યા છીએ…", micUnsupported: "બ્રાઉઝરમાં અવાજ ઈનપુટ નથી. ટાઇપ કરો.", placeholder: "અથવા અહીં લખો…" },
          practice: { label: "અમલમાં લાવવા જેવા વિચારો", subtitle: "તમે ખરેખર શું જુદું કરશો?", placeholder: "પ્રયત્ન કરવા જેવી એક બે વાતો લખો…" },
          passage: { label: "યાદ રાખવા જેવો ભાગ", subtitle: "રાખવા જેવી પંક્તિ", placeholder: "તમને હલાવેલ ભાગ લખો…" },
          revisit: { label: "પછી પાછા આવો", subtitle: "પાછા આવવા લાયક", placeholder: "એક અધ્યાય, એક વિચાર, એક પ્રશ્ન…" },
        },
      },
      step3: { roman: "III", heading: "તમારા વિશે", subheading: "આ વાર્તા કોની છે જાણવા.", namePlaceholder: "તમારું નામ…", emailPlaceholder: "તમારો ઈમેઇલ…", emailNote: "અમે તમારો ઈમેઇલ ક્યારેય શેર કરીશું નહીં. Chapters Within તૈયાર હશે ત્યારે જ લખીશું." },
      submit: "મારો અધ્યાય મુદ્રિત કરો", submitting: "મુદ્રિત કરી રહ્યા છીએ…", bottomTagline: "આ યાદ રાખે છે તમે શું બની રહ્યા છો.",
      validationGeneric: "આ અધ્યાય મુદ્રિત કરવા થોડું વધુ જોઈએ.", validationEmail: "કૃપા કરી માન્ય ઈમેઇલ આપો.", submitErrorGeneric: "કશું ખોટું થયું. ફરી પ્રયત્ન કરો.", close: "બંધ કરો",
    },
    confirmation: { heading: "તમારો અધ્યાય મુદ્રિત થયો.", subtitle: "અમે ધ્યાનથી સ્વીકાર્યા. આશ્રય તૈયાર થશે ત્યારે પહેલા તમે જાણશો.", signoff: "— iCraftz પુસ્તકાલય" },
  },

  ml: {
    sectionTitle: "അകത്തെ അധ്യായങ്ങൾ", sectionSubtitle: "നിങ്ങളുടെ കഥ.",
    sectionTagline: "നിങ്ങൾ വായിക്കുന്ന ഓരോ പുസ്തകവും നിങ്ങൾ ആകുന്ന കഥയിലെ ഒരു അധ്യായമാകുന്നു.",
    sanctuaryLabel: "ഒരു സ്വകാര്യ വായനശാല — ഉടൻ വരുന്നു",
    sanctuaryNote: "ഇന്ന് നിങ്ങളുടെ ചിന്തകൾ പങ്കിടുക. നിങ്ങളുടെ വ്യക്തിഗത ശാല നിർമ്മിക്കപ്പെടുന്നു.",
    cta: "ഒരു അധ്യായം പിടിച്ചെടുക്കുക",
    modal: {
      heading: "നിങ്ങളുടെ അധ്യായം", subheading: "ഈ പുസ്തകം നൽകിയത് പിടിച്ചെടുക്കുക.",
      step1: { roman: "I", heading: "ഏത് പുസ്തകത്തെക്കുറിച്ച് ചിന്തിക്കുന്നു?", placeholder: "തലക്കെട്ട് അല്ലെങ്കിൽ എഴുത്തുകാരൻ…", hint: "ഞങ്ങളുടെ ഗ്രന്ഥശാലയിൽ തിരയുക.", authorPlaceholder: "എഴുത്തുകാരൻ (ഐച്ഛികം)…" },
      step2: { roman: "II", heading: "ഈ പുസ്തകം എന്താണ് നൽകിയത്?", optional: "ഐച്ഛികം",
        cards: {
          reflection: { label: "എന്റെ ചിന്ത", subtitle: "എന്താണ് നിലനിന്നത്?", micLabel: "നിങ്ങളുടെ ചിന്ത പറയുക", micHint: "റെക്കോർഡുചെയ്യാൻ ടാപ്പ്.", micListening: "കേൾക്കുന്നു…", micUnsupported: "ശബ്ദ ഇൻപുട്ട് ഇല്ല. ടൈപ്പ് ചെയ്യുക.", placeholder: "അല്ലെങ്കിൽ ഇവിടെ എഴുതുക…" },
          practice: { label: "പ്രയോഗത്തിലെ ആശയങ്ങൾ", subtitle: "നിങ്ങൾ എന്താണ് വ്യത്യാസമായി ചെയ്യുക?", placeholder: "ശ്രമിക്കാനാഗ്രഹിക്കുന്ന ഒന്നോ രണ്ടോ കാര്യം…" },
          passage: { label: "ഓർക്കാനുള്ള ഭാഗം", subtitle: "സൂക്ഷിക്കാൻ യോഗ്യമായ വരി", placeholder: "നിങ്ങളെ പിടിച്ചുകുലുക്കിയ ഭാഗം…" },
          revisit: { label: "പിന്നീട് മടങ്ങുക", subtitle: "മടങ്ങിവരാൻ യോഗ്യം", placeholder: "ഒരു അധ്യായം, ഒരു ആശയം…" },
        },
      },
      step3: { roman: "III", heading: "നിങ്ങളെപ്പറ്റി", subheading: "ഈ കഥ ആരുടേതെന്നറിയാൻ.", namePlaceholder: "നിങ്ങളുടെ പേര്…", emailPlaceholder: "നിങ്ങളുടെ ഇമെയിൽ…", emailNote: "നിങ്ങളുടെ ഇമെയിൽ പങ്കിടില്ല. Chapters Within തയ്യാറാകുമ്പോൾ മാത്രം എഴുതും." },
      submit: "എന്റെ അധ്യായം മുദ്രവയ്ക്കുക", submitting: "മുദ്രവയ്ക്കുന്നു…", bottomTagline: "ഇത് നിങ്ങൾ ആകുന്നത് ഓർക്കുന്നു.",
      validationGeneric: "ഈ അധ്യായം മുദ്രവയ്ക്കാൻ കുറച്ച് കൂടി വേണം.", validationEmail: "സാധുവായ ഇമെയിൽ നൽകുക.", submitErrorGeneric: "എന്തോ പിശക്. വീണ്ടും ശ്രമിക്കുക.", close: "അടയ്ക്കുക",
    },
    confirmation: { heading: "നിങ്ങളുടെ അധ്യായം മുദ്രവെച്ചു.", subtitle: "ഞങ്ങൾ ശ്രദ്ധയോടെ സ്വീകരിച്ചു. ശാല തയ്യാറാകുമ്പോൾ ആദ്യം നിങ്ങൾ അറിയും.", signoff: "— iCraftz ഗ്രന്ഥശാല" },
  },

  pa: {
    sectionTitle: "ਅੰਦਰੂਨੀ ਅਧਿਆਏ", sectionSubtitle: "ਤੁਹਾਡੀ ਕਹਾਣੀ.",
    sectionTagline: "ਤੁਸੀਂ ਪੜ੍ਹੀ ਹਰ ਕਿਤਾਬ ਉਸ ਕਹਾਣੀ ਦਾ ਇੱਕ ਅਧਿਆਏ ਬਣਦੀ ਹੈ ਜੋ ਤੁਸੀਂ ਬਣ ਰਹੇ ਹੋ.",
    sanctuaryLabel: "ਇੱਕ ਨਿੱਜੀ ਪੜ੍ਹਾਈ ਪਨਾਹ — ਜਲਦ ਆ ਰਹੀ ਹੈ",
    sanctuaryNote: "ਅੱਜ ਆਪਣੇ ਵਿਚਾਰ ਸਾਂਝੇ ਕਰੋ. ਤੁਹਾਡੀ ਨਿੱਜੀ ਪਨਾਹ ਬਣਾਈ ਜਾ ਰਹੀ ਹੈ. ਜਲਦ ਲੈ ਆਵਾਂਗੇ.",
    cta: "ਇੱਕ ਅਧਿਆਏ ਫੜੋ",
    modal: {
      heading: "ਤੁਹਾਡਾ ਅਧਿਆਏ", subheading: "ਇਸ ਕਿਤਾਬ ਨੇ ਜੋ ਦਿੱਤਾ ਉਹ ਫੜੋ.",
      step1: { roman: "I", heading: "ਕਿਸ ਕਿਤਾਬ ਬਾਰੇ ਸੋਚ ਰਹੇ ਹੋ?", placeholder: "ਸਿਰਲੇਖ ਜਾਂ ਲੇਖਕ…", hint: "ਸਾਡੀ ਲਾਇਬ੍ਰੇਰੀ ਖੋਜੋ ਜਾਂ ਪੜ੍ਹੀ ਕਿਤਾਬ ਦਰਜ ਕਰੋ.", authorPlaceholder: "ਲੇਖਕ (ਚੋਣਵੇਂ)…" },
      step2: { roman: "II", heading: "ਇਸ ਕਿਤਾਬ ਨੇ ਤੁਹਾਨੂੰ ਕੀ ਦਿੱਤਾ?", optional: "ਚੋਣਵੇਂ",
        cards: {
          reflection: { label: "ਮੇਰੀ ਪ੍ਰਤੀਬਿੰਬਨਾ", subtitle: "ਕੀ ਤੁਹਾਡੇ ਨਾਲ ਰਿਹਾ?", micLabel: "ਆਪਣੀ ਪ੍ਰਤੀਬਿੰਬਨਾ ਬੋਲੋ", micHint: "ਰਿਕਾਰਡ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ.", micListening: "ਸੁਣ ਰਹੇ ਹਾਂ…", micUnsupported: "ਆਵਾਜ਼ ਇਨਪੁਟ ਨਹੀਂ ਹੈ. ਟਾਈਪ ਕਰੋ.", placeholder: "ਜਾਂ ਇੱਥੇ ਲਿਖੋ…" },
          practice: { label: "ਅਮਲ ਵਿੱਚ ਲਿਆਉਣ ਯੋਗ ਵਿਚਾਰ", subtitle: "ਤੁਸੀਂ ਅਸਲ ਵਿੱਚ ਕੀ ਵੱਖਰਾ ਕਰੋਗੇ?", placeholder: "ਅਜ਼ਮਾਉਣ ਯੋਗ ਇੱਕ ਦੋ ਗੱਲਾਂ ਲਿਖੋ…" },
          passage: { label: "ਯਾਦ ਰੱਖਣ ਯੋਗ ਹਿੱਸਾ", subtitle: "ਰੱਖਣ ਯੋਗ ਪੰਕਤੀ", placeholder: "ਜੋ ਤੁਹਾਨੂੰ ਹਿਲਾਏ ਉਹ ਹਿੱਸਾ ਲਿਖੋ…" },
          revisit: { label: "ਬਾਅਦ ਵਿੱਚ ਮੁੜੋ", subtitle: "ਮੁੜਨ ਯੋਗ", placeholder: "ਇੱਕ ਅਧਿਆਏ, ਇੱਕ ਵਿਚਾਰ…" },
        },
      },
      step3: { roman: "III", heading: "ਤੁਹਾਡੇ ਬਾਰੇ", subheading: "ਇਹ ਕਹਾਣੀ ਕਿਸਦੀ ਹੈ ਜਾਣਨ ਲਈ.", namePlaceholder: "ਤੁਹਾਡਾ ਨਾਮ…", emailPlaceholder: "ਤੁਹਾਡਾ ਈਮੇਲ…", emailNote: "ਅਸੀਂ ਤੁਹਾਡਾ ਈਮੇਲ ਕਦੇ ਸਾਂਝਾ ਨਹੀਂ ਕਰਾਂਗੇ. Chapters Within ਤਿਆਰ ਹੋਣ ਤੇ ਹੀ ਲਿਖਾਂਗੇ." },
      submit: "ਮੇਰੇ ਅਧਿਆਏ ਨੂੰ ਮੁਹਰ ਲਾਓ", submitting: "ਮੁਹਰ ਲਾ ਰਹੇ ਹਾਂ…", bottomTagline: "ਇਹ ਯਾਦ ਰੱਖਦਾ ਹੈ ਤੁਸੀਂ ਕੀ ਬਣ ਰਹੇ ਹੋ.",
      validationGeneric: "ਇਸ ਅਧਿਆਏ ਨੂੰ ਮੁਹਰਬੰਦ ਕਰਨ ਲਈ ਥੋੜ੍ਹਾ ਹੋਰ ਚਾਹੀਦਾ.", validationEmail: "ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਈਮੇਲ ਦਿਓ.", submitErrorGeneric: "ਕੁਝ ਗਲਤ ਹੋਇਆ.", close: "ਬੰਦ ਕਰੋ",
    },
    confirmation: { heading: "ਤੁਹਾਡਾ ਅਧਿਆਏ ਮੁਹਰਬੰਦ ਹੋ ਗਿਆ.", subtitle: "ਅਸੀਂ ਧਿਆਨ ਨਾਲ ਪ੍ਰਾਪਤ ਕੀਤੇ. ਪਨਾਹ ਤਿਆਰ ਹੋਣ ਤੇ ਪਹਿਲਾਂ ਤੁਸੀਂ ਜਾਣੋਗੇ.", signoff: "— iCraftz ਲਾਇਬ੍ਰੇਰੀ" },
  },
};

export default chaptersWithinTranslations;
